import modalStore from '@src/application/store/modals-store.js';
import { type Component, markRaw } from 'vue';
import Modal from '@src/application/modal.js';
import ModalApproveComponent from '@src/application/modals/modal-approve-component.vue';
import ModalAbort from '@src/application/modals/modal-abort-component.vue';
import ModalError from '@src/application/modals/modal-error.vue';
import { v4 } from 'uuid';
import { ModalSize } from '@src/application/types/modal-size.ts';

export function setModal(modal: Modal): void {
    modalStore.modals.data.unshift(modal);
}

export function unsetModal(uuid: string): void {
    for (let i = 0; i < modalStore.modals.data.length; i++) {
        if (modalStore.modals.data[i].uuid !== uuid) {
            continue;
        }
        modalStore.modals.data.splice(i, 1);
        return;
    }
}

export function createModal<ReturnType = void>(title: string|false, component: string|Component, resolveListener: string, rejectListener: string|null = null, props: object|null = null, size: ModalSize = null): Promise<ReturnType> {
    if (document.activeElement !== null && document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }
    if (typeof component !== 'string') {
        markRaw(component);
    }
    return new Promise((resolve, reject) => {
        setModal(new Modal(
            v4(),
            title,
            component,
            resolve,
            reject,
            resolveListener,
            rejectListener,
            props,
            size,
        ));
    });
}

export function createModalApproveComponent(title: string|false, message: string, component: Component|null = null, resolveListener: string = 'resolve', resolveText: string = 'Ja', rejectText: string|false = 'Nein', props: object|null = null, size: ModalSize = null): Promise<void> {
    return createModal(
        title,
        ModalApproveComponent,
        resolveListener,
        'reject',
        {
            component: component !== null ? markRaw(component) : null,
            resolveListener,
            message,
            resolveText,
            rejectText,
            props,
        },
        size,
    );
}

export function createModalAbort<returnType = void>(title: string|false, component: Component, resolveListener: string|null = null, props: object|null = null, size: ModalSize = null): Promise<returnType> {
    let rejectListener: string|null = 'reject';
    if (resolveListener === null) {
        resolveListener = 'reject';
        rejectListener = null;
    }
    return createModal(
        title,
        ModalAbort,
        resolveListener,
        rejectListener,
        {
            component: markRaw(component),
            resolveListener,
            props,
        },
        size,
    );
}

export function createErrorModal(title: string|false, errorMessage: string, onConfirm: void|null = null, size: ModalSize = null): Promise<void> {
    return createModal(
        title,
        ModalError,
        'confirm',
        null,
        {
            title: title,
            message: errorMessage,
            onConfirm: onConfirm,
        },
        size,
    );
}
